import { readCookie } from "@packages/util/cookie/cookie";

const LOCALE_COOKIE = "wf_locale";
const LOCALE_STORAGE_KEY = "locale";
const COOKIE_MAX_AGE = 86400 * 365;

const COOKIE_TO_LOCALE = { pt: "pt-BR", en: "en", es: "es" };

function toCookieValue(locale) {
    const language = String(locale || "").toLowerCase().split(/[-_]/)[0];

    return COOKIE_TO_LOCALE[language] ? language : "";
}

export function readLocaleCookie() {
    return COOKIE_TO_LOCALE[readCookie(LOCALE_COOKIE)] || null;
}

export function writeLocaleCookie(locale) {
    const value = toCookieValue(locale);

    if (!value) return;

    const secure = window.location.protocol === "https:" ? "; secure" : "";

    document.cookie = `${LOCALE_COOKIE}=${encodeURIComponent(value)}; path=/; max-age=${COOKIE_MAX_AGE}; samesite=lax${secure}`;
}

export function resolveLocale() {
    const fromCookie = readLocaleCookie();

    if (fromCookie) {
        localStorage.setItem(LOCALE_STORAGE_KEY, fromCookie);

        return fromCookie;
    }

    const fromStorage = localStorage.getItem(LOCALE_STORAGE_KEY);

    if (fromStorage) {
        writeLocaleCookie(fromStorage);

        return fromStorage;
    }

    return navigator.language;
}
